import { useState } from 'react';

import { RolesApi } from '@/api/clients/roles/roles.api';

export const useUpdateRoleCustomPaymentTypeAccess = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateRoleCustomPaymentTypeAccess = async (roleId, roleData) => {
    setLoading(true);
    setError(null);

    try {
      await RolesApi.updateRoleCustomPaymentTypeAccess(roleId, roleData);
    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        'Failed to update role custom payment type access';
      setError(errorMessage);
      console.error('Error updating role custom payment type access:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    updateRoleCustomPaymentTypeAccess,
    loading,
    error,
  };
};
